import styles from '@ui/components/Badge/Badge.module.scss';
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const Badge = ({
  children,
  className = null,
  size = 'default',
  theme = 'modest',
  variant = 'default',
}) => (
  <div
    className={classNames(
      styles.container,
      styles[theme],
      styles[`${size}Size`],
      styles[`${variant}Variant`],
      className,
    )}
  >
    <div>{children}</div>
  </div>
);

Badge.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  size: PropTypes.oneOf(['default', 'large']),
  theme: PropTypes.oneOf(['modest', 'harsh', 'dimmed']),
  variant: PropTypes.oneOf(['default', 'normal']),
};

export default Badge;
